import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { styled } from '@mui/material/styles';
import { XvAppId } from '@im/ui-lib/mf-utils';

export const ErrorContentBasic = ({ appId }: { appId: XvAppId }) => {
  return (
    <Root id="error-boundary-basic">
      <img
        alt={'Something went wrong'}
        src="/xshared/assets/img/errorBoundary.svg"
        style={{ marginBottom: '50px' }}
      />
      <Typography sx={{ fontSize: '14px', lineHeight: '22px' }}>
        It's difficult being the first but we're always trying to give our
        customers the Xvantage.
      </Typography>
      <Typography sx={{ fontSize: '14px', lineHeight: '22px' }}>
        We're currently transforming this service to provide the better
        experience and competitive edge you deserve.
      </Typography>

      <Typography
        sx={{ fontSize: '20px', lineHeight: '28px', margin: '32px 0px' }}
        variant="h2"
      >
        Please return to this page at a later time.
      </Typography>
      <Button
        href={`/${appId}/app/home`}
        startIcon={<ArrowBackIcon />}
        sx={{ fontSize: '14px', lineHeight: '22px', textTransform: 'none' }}
        variant="contained"
      >
        Back to home
      </Button>
    </Root>
  );
};
const Root = styled('div')(() => ({
  margin: '50px auto 0px',
  maxWidth: '1500px',
  textAlign: 'center',
}));
